<template>
  <div>
    <div class="vx-card mt-6">
      <div class="vx-card__body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <form v-if="showFilters">
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
              <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
              <v-select
                label="name"
                name="warehouse"
                :options="allWarehouses"
                v-model="gridSearchData.id"
                v-validate="{ required: true }"
                :reduce="(x) => x.id"
                @input="changeWarehouse"
                ref="warehouseSelect"
                :clearable="true"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm mt-3"
                v-show="errors.has('warehouse')"
                >{{ errors.first("warehouse") }}</span
              >
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
              <label class="vs-select--label">{{ $t("ShelveName") }}</label>
              <v-select
                label="name"
                name="shelve"
                :options="shelves"
                v-model="gridSearchData.shelveId"
                :reduce="(x) => x.id"
                ref="shelveSelect"
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.FromDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('FromDate')"
                :clearable="true"
              />
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>

              <date-picker
                v-model="gridSearchData.ToDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('ToDate')"
                :clearable="true"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </form>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ProductName'), sort: 'ProductName' },
                {
                  title: $t('BalanceForTheBeginningOfHistory'),
                  sort: 'BalanceForTheBeginningOfHistory',
                },
                { title: $t('CheckInCount'), sort: 'CheckInCount' },
                { title: $t('CheckOutCount'), sort: 'CheckOutCount' },
                { title: $t('Balance'), sort: 'Balance' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 57%">
                  {{ row.stockName }}
                </td>
                <td style="width: 10%">
                  {{ row.balanceInTotalStoreAtBegin }}
                  {{ row.balanceInSpecificStoreAtBegin }}
                  {{ row.balanceInSpecificShelveAtBegin }}
                </td>
                <td style="width: 10%">
                  {{ row.countOfCheckIn }}
                </td>
                <td style="width: 10%">
                  {{ row.countOfCheckOut }}
                </td>
                <td style="width: 10%">
                  {{ row.balance }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

.vs-select--label {
  display: block;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "../../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";

const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Reports_StockCirculation_Index",
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    DataGrid,
  },
  data() {
    return {
      id: null,
      fromDate: "",
      toDate: "",
      gridDataSource: {
        type: "app",
        service: "Inventory/api/CirculationOfStockQuery",
      },
      gridSearchData: {},
      showFilters: false,
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/list",
    }),
    shelves() {
      var warehouse = this.$store.getters["warehouse/list"].find(
        (obj) => obj.id == this.gridSearchData.id
      );
      return warehouse ? warehouse.shelveQueries : [];
    },
  },
  mounted() {
    this.fetchWarehouses();
  },
  methods: {
    ...mapActions({
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",
    }),
    changeWarehouse() {
      this.gridSearchData.shelveId == null;
      this.$refs.shelveSelect.clearSelection();
    },
    submitFilter() {
      if (
        this.gridSearchData.FromDate == this.gridSearchData.ToDate ||
        this.gridSearchData.FromDate < this.gridSearchData.ToDate ||
        (this.gridSearchData.FromDate != "" && this.gridSearchData.ToDate == "")
      ) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.gridSearchData = {
              id: this.gridSearchData.id,
              FromDate: this.gridSearchData.FromDate,
              ToDate: this.gridSearchData.ToDate,
            };
            this.$refs.grid.renderGrid(1, true);
          }
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
      }
    },
    resetForm() {
      this.gridSearchData = {};
      this.$refs.shelveSelect.clearSelection();
      this.$refs.warehouseSelect.clearSelection();
      this.$validator.reset();
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
